import { AmplitudeFlagKey } from "@simplyk/common";

import { useAmplitudeFeatureFlag } from "@/common/hooks/amplitude/useAmplitudeFeatureFlag";

export const useCustomColorTileExperiment = (organizationId: string | undefined) => {
  const { isActive, loading } = useAmplitudeFeatureFlag({
    flagKey: AmplitudeFlagKey.CustomColorTileExperiment,
    organizationId,
    skip: !organizationId,
  });

  return {
    isCustomColorTileActive: isActive,
    isCustomColorTileLoading: loading,
  };
};
